const MIN_TABLE_WIDTH_FOR_SINGLE_LINE_ROW = 451;
const MIN_TABLE_WIDTH_FOR_DOUBLE_LINE_ROW = 352;
const MIN_TABLE_WIDTH_FOR_RESPONSIVE_VERSION = 443;

export {
    MIN_TABLE_WIDTH_FOR_SINGLE_LINE_ROW,
    MIN_TABLE_WIDTH_FOR_DOUBLE_LINE_ROW,
    MIN_TABLE_WIDTH_FOR_RESPONSIVE_VERSION,
};
